export class BalanceStructure {
    constructor(public readonly zeroBalance: number,
        public readonly safetyStockZone: number,
        public readonly redZone: number,
        public readonly yellowZone: number,
        public readonly greenZone: number,
        public readonly overstockZone: number) {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/assortment-structure/balance-structure.ts